import React from 'react';
import './HistoryPatient.css';

const HistoryPatient = () => {
  const appointmentHistory = [
    { doctor: 'Dr. John Smith', date: '2025-05-15', time: '10:00 AM', status: 'Completed' },
    { doctor: 'Dr. Sarah Patel', date: '2025-04-10', time: '02:30 PM', status: 'Completed' },
  ];

  const medicationHistory = [
    { medicine: 'Paracetamol', date: '2025-05-15', quantity: 2, price: '₹50', status: 'Delivered' },
    { medicine: 'Amoxicillin', date: '2025-04-10', quantity: 1, price: '₹100', status: 'Delivered' },
  ];

  const reportHistory = [
    { reportName: 'Blood Test', date: '2025-05-16', result: 'Normal' },
    { reportName: 'X-Ray Chest', date: '2025-04-12', result: 'Clear' },
  ];

  return (
    <div className="history-tab" style={{ padding: '20px' }}>
      <h3>Appointment History</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Doctor</th>
            <th>Date</th>
            <th>Time</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {appointmentHistory.map((appt, index) => (
            <tr key={index}>
              <td>{appt.doctor}</td>
              <td>{appt.date}</td>
              <td>{appt.time}</td>
              <td>{appt.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: '30px' }}>Medication History</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Medicine</th>
            <th>Date</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {medicationHistory.map((med, index) => (
            <tr key={index}>
              <td>{med.medicine}</td>
              <td>{med.date}</td>
              <td>{med.quantity}</td>
              <td>{med.price}</td>
              <td>{med.status}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 style={{ marginTop: '30px' }}>Lab History</h3>
      <table className="full-width-table">
        <thead>
          <tr>
            <th>Report Name</th>
            <th>Date</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          {reportHistory.map((report, index) => (
            <tr key={index}>
              <td>{report.reportName}</td>
              <td>{report.date}</td>
              <td>{report.result}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistoryPatient;
